/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { Admin, DummyDoNotUse, Preset, PresetCategory, Recipe, StandardProduct } from './admin-model/index.js';
export const constants = {};
const PresetCategoryExpressions = [
    '$isDraft',
    '$admin',
    '$presets'
];
const AdminExpressions = [
    '$standardProducts',
    '$presets',
    '$presetCategories',
    '$recipes'
];
const PresetExpressions = [
    '$admin',
    '$category',
    '$violations'
];
const RecipeExpressions = [
    '$admin'
];
export const $Admin = new $DomainEntityReflection('Admin', [
    ...AdminExpressions
]);
export const $Preset = new $DomainEntityReflection('Preset', [
    ...PresetExpressions
]);
export const $PresetCategory = new $DomainEntityReflection('PresetCategory', [
    ...PresetCategoryExpressions
]);
export const $Recipe = new $DomainEntityReflection('Recipe', [
    ...RecipeExpressions
]);
export const $DummyDoNotUse = new $DomainEntityReflection('DummyDoNotUse', []);
export const $StandardProduct = new $DomainEntityReflection('StandardProduct', []);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type,
    DummyDoNotUse.type,
    StandardProduct.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Admin.type
]);
export const $CommonAdminEntity = new EnhancedAliasReflection('$CommonAdminEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type
]);
export const $entityReflections = {
    Admin: $Admin,
    Preset: $Preset,
    PresetCategory: $PresetCategory,
    Recipe: $Recipe,
    DummyDoNotUse: $DummyDoNotUse,
    StandardProduct: $StandardProduct
};

//# sourceMappingURL=admin-enhanced-model.js.map